const STATUS_STYLE = {
  concept: "bg-slate-100 text-slate-700 border-slate-200",
  submitted: "bg-cyan-100 text-cyan-700 border-cyan-200",
  in_review: "bg-indigo-100 text-indigo-700 border-indigo-200",
  approved: "bg-teal-100 text-teal-700 border-teal-200",
  ordered: "bg-sky-100 text-sky-700 border-sky-200",
  partially_received: "bg-amber-100 text-amber-700 border-amber-200",
  received: "bg-emerald-100 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
  unknown: "bg-zinc-100 text-zinc-700 border-zinc-200",
};

const STATUS_LABEL = {
  concept: "Concept",
  submitted: "Ingediend",
  in_review: "In beoordeling",
  approved: "Goedgekeurd",
  ordered: "Besteld",
  partially_received: "Deels geleverd",
  received: "Geleverd",
  rejected: "Afgewezen",
  unknown: "Onbekend",
};

const DISPLAY_KEY_BY_STATUS = {
  concept: "concept",
  nog_te_koppelen: "concept",
  requested: "submitted",
  under_review: "in_review",
  approval_pending: "in_review",
  gekoppeld: "in_review",
  approved: "approved",
  approved_for_ordering: "approved",
  gecontroleerd: "approved",
  confirmed: "approved",
  ordered: "ordered",
  besteld: "ordered",
  sent: "ordered",
  in_progress: "ordered",
  partially_received: "partially_received",
  opgehaald: "partially_received",
  received: "received",
  ontvangen: "received",
  closed: "received",
  completed: "received",
  rejected: "rejected",
  cancelled: "rejected",
};

function resolveDisplayStatus(status, displayStatus) {
  const preferred = String(displayStatus || "").trim().toLowerCase();
  if (preferred && STATUS_STYLE[preferred]) return preferred;
  const raw = String(status || "").trim().toLowerCase();
  return DISPLAY_KEY_BY_STATUS[raw] || "unknown";
}

export default function ProcurementOrderStatusBadge({ status, displayStatus, label }) {
  const key = resolveDisplayStatus(status, displayStatus);
  const style = STATUS_STYLE[key] || STATUS_STYLE.unknown;
  const text = String(label || "").trim() || STATUS_LABEL[key] || STATUS_LABEL.unknown;

  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${style}`}>
      {text}
    </span>
  );
}
